import * as Yup from 'yup';

const addResourceSchema = Yup.object().shape({
  resourceName: Yup.string().required('resourceNameRequired'),
  resourceDescription: Yup.string().nullable(),
  devicesInThisResource: Yup.array().nullable(),
});

export default addResourceSchema;

